/**
 * 创建人：杨万武
 * 时间：2019-9-20
 * 描述：将流程对应状态转换为文字
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


/**
 * 流程状态管道
 *  @example <td [innerHTML]="data.state | procState"></td>
 *  @example<td [attr.pid]="data.procInstId" SwWorkFlow [innerHTML]="data.procStatus | procState:data.nextHandler"></td>
 */
@Pipe({
  name: 'procState'
})
export class ProcStatePipe implements PipeTransform {


  //获取当前dom节点
  constructor(private dom: DomSanitizer) { }

  transform(value: string,handlerName?:any): any {
    value = value.toString()
    // switch (value){
    //   case "审核中":  return handlerName? this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info">${handlerName+'：'}审批中</span>`): this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info">审批中</span>`); 
    //   case "退回":  return handlerName? this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info">${handlerName+'：'}审批中</span>`): this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info">审批中</span>`); 
    //   case "拒绝":  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">已拒绝</span>`); 
    //   case "审核通过":  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-success">审批通过</span>`); 
    //   case "已撤销":  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">已撤销</span>`); 
    //   }

    
    if(value == "审核中" || value == "退回" || value == "已撤回"){
      if(handlerName){
        let handlers = handlerName.split(',')
        if(handlers.length == 1){
          // 如果只有一个处理人
          return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info">${handlers[0]+'：'}审批中</span>`)
        } else if(handlers.length > 1){
          //如果有多个处理人，就只显示第一个人的名字加上‘等’,然后鼠标浮上去显示所有人
          return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer" title=${handlerName}  class="state-info">${handlers[0]+' 等：'}审批中</span>`)
        }
      } else {
        return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info">审批中</span>`)
      }
    } else if(value == "拒绝"){
      return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">已拒绝</span>`)
    } else if(value == "审核通过"){
      return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-success">审批通过</span>`)
    } else if(value == "已撤销"){
      return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">已撤销</span>`)
    }
  }
}
